import Inputmask from "inputmask"

export class CadastroMask {
  constructor() {
    this.cpfElement = document.querySelector("#cpf-id")
    this.telefoneElement = document.querySelector("#phone-id")

    this.init()
  }

  init() {
    Inputmask.extendDefaults({
      'autoUnmask': true
    });

    if(this.cpfElement)
      Inputmask("999.999.999-99").mask(this.cpfElement)
    if(this.telefoneElement)
      Inputmask("(99) 9 9999-9999").mask(this.telefoneElement)
  }

}



// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/components/newsletter/masks.js